import MapContainer from "./Map";

export default MapContainer;
